import ApiBase from './api_base'

export function weixinConfig() {
  return ApiBase.get('/wechat/signature.json')
}



// WEBPACK FOOTER //
// ./src/api/miscellaneous.js